import clsx from "clsx";

const severityStyles = {
  info: {
    bar: "bg-[#2E9BFF]",
    bg: "bg-[#2E9BFF26]",
  },
  warning: {
    bar: "bg-[#FF922E]",
    bg: "bg-[#FFF7ED]",
  },
  error: {
    bar: "bg-red-500",
    bg: "bg-red-500/15",
  },
  success: {
    bar: "bg-[#2EFF7B]",
    bg: "bg-[#2EFF7B26]",
  },
  disabled: {
    bar: "bg-[#8F8F8F]",
    bg: "bg-[#8F8F8F26]",
  }
};

export const AlertBanner = ({ severity = "info", children, className }) => {
  const styles = severityStyles[severity];

  return (
    <div className={clsx("flex flex-row", className)}>
      <div className={clsx("w-2 rounded-s-lg", styles.bar)} />

      <div className={clsx("flex-1 rounded-e-lg", styles.bg)}>
        {children}
      </div>
    </div>
  );
};